import {
  TABLE_MANAGEMENT_GROUP_PAGE_REQUEST,
  TABLE_MANAGEMENT_GROUP_LIST_REQUEST,
  TABLE_MANAGEMENT_GROUP_ON_CHANGE_OUTLET_IDS,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_ROW,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_CANCEL,
  TABLE_MANAGEMENT_GROUP_ON_CLICK_CREATE_GROUP,
  TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_CREATE,
  TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_UPDATE,
  TABLE_MANAGEMENT_GROUP_DELETE_REQUEST,
  TABLE_MANAGEMENT_GROUP_CANCEL_DELETE,
  TABLE_MANAGEMENT_GROUP_DELETE,
  TABLE_MANAGEMENT_GROUP_SET_FILTER,
  TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP,
  TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP_CANCEL
} from 'actions/tableManagement/constants'
import {call, put, takeLatest} from 'redux-saga/effects'
import {initialize, change, reset} from 'redux-form'

import * as apiOutlets from 'api/outlets'
import * as actTableManagement from 'actions/tableManagement'
import * as apiProfile from 'api/profile'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as apiTableManagement from 'api/tableManagement'
import {setSelectedOutletIds} from 'actions/actionBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpTableManagement from 'mixpanel/tableManagement'
import _cloneDeep from 'lodash/cloneDeep'
import _orderBy from 'lodash/orderBy'

export const getBusinessId = state => state.moka.user.business.id
export const getOutletId = state => state.moka.user.outlet_id[0]

function * fillForm (group) {
  yield put(initialize('search', {
    search: group.search
  }))
}

export function * fetchSummary (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiTableManagement.getGroupSummary)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
    return false
  } finally {
    yield put(act.hideProgressBar())
  }
}

function * setFilterTableGroup (request) {
  const {search, groups} = request.payload
  const sanitize = search.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
  let pattern = new RegExp(sanitize, 'i')
  let filteredGroups = _cloneDeep(groups)
  if (sanitize && sanitize !== '') {
    filteredGroups = filteredGroups.filter((group) => pattern.test(group.name))
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
  } else {
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
  }
}

function * fillSearch (profile) {
  let assignedOutletIds = []
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]]
  } else {
    assignedOutletIds = profile.outlet_id
  }
  let data = {'outletIds': assignedOutletIds}
  yield put(initialize('search', data))
}

export function * onChangeOutletIds (request) {
  yield put(actTableManagement.closeRightColumn())
  yield put(actTableManagement.setGroups([]))
  yield put(actTableManagement.setFilteredGroups([]))
  yield put(actTableManagement.setGroupSummary([]))
  yield put(actTableManagement.setGroupDetail(null))
  yield put(actTableManagement.setTables([]))
  yield put(actTableManagement.setOriginalTables([]))
  yield put(showPageLoadingSpinner(true))
  const {payload: {outletIds}} = request
  try {
    yield put(act.showProgressBar())
    yield call(apiOutlets.patchLogin, {id: outletIds})
    let resProfile = yield call(apiProfile.getProfile)
    yield put(setSelectedOutletIds(outletIds))
    yield put(change('search', 'outletIds', outletIds))
    yield put(actTableManagement.unSetFilterState())
    yield call(fillForm, {search: ''})
    yield call(fillSearch, resProfile.data)
    yield call(groupsRequest, {page: 1, keyword: ''})
    yield put(actTableManagement.groupSummaryRequest({}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * groupPageRequestFlow () {
  yield put(showPageLoadingSpinner(true))
  yield put(actTableManagement.setGroups([]))
  yield put(actTableManagement.setFilteredGroups([]))
  yield put(actTableManagement.setGroupSummary([]))
  yield put(actTableManagement.setGroupDetail(null))
  yield put(actTableManagement.closeRightColumn())
  yield put(act.showProgressBar())
  try {
    yield call(fillForm, {search: ''})
    yield call(groupsRequest, {page: 1, keyword: ''})
    let response = yield call(apiOutlets.outlets)
    yield put(actTableManagement.setOutlets(response.data))
    let resProfile = yield call(apiProfile.getProfile)
    yield call(fillSearch, resProfile.data)
    yield put(actTableManagement.groupSummaryRequest({}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * getTableGroups (params) {
  yield put(act.showProgressBar())
  try {
    let response = yield call(apiTableManagement.getTableGroups, params)
    return response.data
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * groupsRequest (request) {
  let keyword, page, previousGroups, groups
  if (request.payload) {
    let requestPayload = request.payload.query
    let filterState = requestPayload.filterState
    previousGroups = request.payload.previousGroups
    keyword = filterState.keyword
    page = requestPayload.page
  } else {
    keyword = request.keyword
    page = request.page
  }
  let query = {
    page: page,
    keyword: !keyword ? '' : keyword
  }
  yield put(act.showProgressBar())
  try {
    let groupsResponse = yield call(getTableGroups, query)
    if (previousGroups) {
      groups = previousGroups.concat(groupsResponse)
    } else {
      groups = groupsResponse
    }
    groups = _orderBy(groups, ['name'], ['asc'])
    yield put(actTableManagement.setGroups(groups))
    let filteredGroups = _cloneDeep(groups)
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
    if (page <= 1) {
      let summary = yield call(fetchSummary, query)
      yield put(actTableManagement.setGroupSummary(summary))
      yield put(actTableManagement.setTotalPage(summary.total_pages))
    }
    yield put(actTableManagement.setCurrentPage(page))
    mpTableManagement.tableGroupStart({ totalTableGroup: groups.count })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
  yield put(showPageLoadingSpinner(false))
}

export function * clickCancel () {
  yield put(actTableManagement.setGroupDetail(null))
  yield put(reset('table-management-group'))
  yield put(actTableManagement.closeRightColumn())
}

export function * clickGroupRow (request) {
  let {payload: {group}} = request
  try {
    yield put(reset('table-management-group'))
    yield put(actTableManagement.setGroupDetail(null))
    yield put(act.showProgressBar())
    const groupDetailRes = yield call(apiTableManagement.getTableGroup, group.id, {})
    const {data: groupDetail} = groupDetailRes
    yield put(actTableManagement.setGroupDetail(groupDetail))
    yield put(initialize('table-management-group', {...groupDetail}))
    yield put(actTableManagement.setMustScrollTop(true))
    yield put(actTableManagement.openRightColumn())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTableManagement.setMustScrollTop(false))
  }
}

export function * clickCreateGroup () {
  yield put(actTableManagement.onClickCancel())
  yield put(act.showProgressBar())
  try {
    yield put(actTableManagement.setGroupDetail(null))
    yield put(actTableManagement.setMustScrollTop(true))
    yield put(actTableManagement.openRightColumn())
    yield put(initialize('table-management-group', { name: '', numberOfTables: 0 }))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTableManagement.setMustScrollTop(false))
  }
}

export function * submitFormCreate (request) {
  const {payload: {values, previousGroups}} = request
  yield put(act.showProgressBar())
  yield put(actTableManagement.isSubmittingForm(true))
  try {
    let response = yield call(apiTableManagement.createTableGroup, values, {})
    let groupData = response.data
    const groups = [groupData]
    previousGroups.forEach(group => {
      groups.push(group)
    })
    mpTableManagement.createTableGroupSuccess({name: groupData.name, active: groupData.active})
    yield put(initialize('table-management-group', groupData))
    yield put(actNotif.success(`Table Group "${groupData.name}" successfully created.`))
    yield put(actTableManagement.setGroups(groups))
    let filteredGroups = _cloneDeep(groups)
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
    yield put(actTableManagement.setGroupDetail(groupData))
  } catch (error) {
    yield put(actNotif.error(error.data.messages[0]))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actTableManagement.isSubmittingForm(false))
  }
}

export function * submitFormUpdate (request) {
  const {payload: {id, values, previousGroups}} = request
  try {
    yield put(act.showProgressBar())
    yield put(actTableManagement.setIsSubmittingForm(true))
    const updatedGroupRes = yield call(apiTableManagement.editTableGroup, id, values, {})
    const updatedGroup = updatedGroupRes.data
    const groups = []
    let oldName = ''
    let newName = ''
    let oldStatus = false
    let newStatus = false
    let tableCount = 0
    previousGroups.forEach(group => {
      if (group.id === id) {
        oldName = group.name
        newName = updatedGroup.name
        oldStatus = group.active
        newStatus = updatedGroup.active
        tableCount = group.numberOfTables
        groups.push(updatedGroup)
      } else {
        groups.push(group)
      }
    })
    mpTableManagement.tableGroupUpdate({oldName, newName, newStatus, oldStatus, tableCount})
    yield put(initialize('table-management-group', updatedGroup))
    yield put(actTableManagement.setGroups(groups))
    let filteredGroups = _cloneDeep(groups)
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
    yield put(actTableManagement.setGroupDetail(updatedGroup))
    yield put(actNotif.success(`Table Group "${newName}" successfully saved.`))
  } catch (error) {
    yield put(actNotif.error(error.data.messages[0]))
  } finally {
    yield put(actTableManagement.setIsSubmittingForm(false))
    yield put(act.hideProgressBar())
  }
}

export function * deleteGroupRequest (request) {
  const {payload: {deletedGroup}} = request
  yield put(actTableManagement.setDeletedGroup(deletedGroup))
  yield put(actTableManagement.showDeleteModal())
}

export function * deleteGroupFlow (request) {
  let {payload: {id, previousGroups}} = request
  yield put(act.showProgressBar())
  try {
    yield call(apiTableManagement.deleteTableGroup, id, {})
    const groups = []
    let deletedName = ''
    let deletedTableCount = 0
    previousGroups.forEach((group) => {
      if (group.id !== id) {
        groups.push(group)
      } else {
        deletedName = group.name
        deletedTableCount = group.numberOfTables
      }
    })
    mpTableManagement.createTableGroupDeleted({deletedName, deletedTableCount})
    yield put(actTableManagement.setGroups(groups))
    let filteredGroups = _cloneDeep(groups)
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
    yield put(actTableManagement.setGroupDetail(null))
    yield put(actTableManagement.setDeletedGroup(null))
    yield put(actTableManagement.hideDeleteModal())
    yield put(actTableManagement.closeRightColumn())
    yield put(actNotif.success(`Table group "${deletedName}" successfully removed.`))
  } catch (error) {
    yield put(actNotif.error(error.data.messages[0]))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * cancelDeleteGroupFlow () {
  mpTableManagement.createTableGroupDeleteCancel()
  yield put(actTableManagement.setDeletedGroup(null))
  yield put(actTableManagement.hideDeleteModal())
}

export function * cancelDuplicateGroup (request) {
  mpTableManagement.tableGroupDuplicateCancel()
}

export function * duplicateGroup (request) {
  let {payload: {group, groups}} = request
  yield put(act.showProgressBar())
  try {
    const groupRes = yield call(apiTableManagement.duplicateTableGroup, group.id, {})
    const {name, numberOfTables} = groupRes.data
    const {active} = group
    groups = groups.concat(groupRes.data)
    groups = _orderBy(groups, ['name'], ['asc'])
    yield put(actTableManagement.setGroups(groups))
    let filteredGroups = _cloneDeep(groups)
    yield put(actTableManagement.setFilteredGroups(filteredGroups))
    yield put(actTableManagement.setGroupDetail(null))
    yield put(actNotif.success(`Table group "${groupRes.data.name}" successfully duplicated.`))
    mpTableManagement.tableGroupDuplicateConfirm({name, active, numberOfTables})
  } catch (error) {
    yield put(actNotif.error(error.data.messages[0]))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export default function * tableManagementGroupSaga () {
  yield takeLatest(TABLE_MANAGEMENT_GROUP_SET_FILTER, setFilterTableGroup)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_PAGE_REQUEST, groupPageRequestFlow)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_LIST_REQUEST, groupsRequest)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_ON_CHANGE_OUTLET_IDS, onChangeOutletIds)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_ON_CLICK_ROW, clickGroupRow)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_ON_CLICK_CANCEL, clickCancel)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_ON_CLICK_CREATE_GROUP, clickCreateGroup)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_DELETE_REQUEST, deleteGroupRequest)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_DELETE, deleteGroupFlow)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_CANCEL_DELETE, cancelDeleteGroupFlow)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP, duplicateGroup)
  yield takeLatest(TABLE_MANAGEMENT_GROUP_DUPLICATE_GROUP_CANCEL, cancelDuplicateGroup)
}



// WEBPACK FOOTER //
// ./app/sagas/tableManagement/group.js